
import actions from './actions'
import mutations, { mutations as MUTATIONS } from './mutations'

let state = {
    all: null,
    currentListeId: null
}

const ACTIONS = {
    GET_ALL: 'listes/getAll',
    SET_CURRENT_LISTE_ID: 'listes/setCurrentListeId'
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}

export { ACTIONS as actions }
export { MUTATIONS as mutations }